import { render, staticRenderFns } from "./dimension-form.vue?vue&type=template&id=b0983538&scoped=true&"
import script from "./dimension-form.vue?vue&type=script&lang=ts&"
export * from "./dimension-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0983538",
  null
  
)

export default component.exports